const rules = {
  required: [(v) => !!v || "Required"],
  selectRequired: [(v) => !!v.length > 0 || "required"],
  multiSelectRequired: [
    (v) => !!v || "Required",
    (v) => !!v.length > 0 || "required",
  ],
  objectRequired: [
    (v) => {
      if (v) {
        if (typeof v == "object") {
          return !!v.number || "required";
        } else {
          return !!v || "Required";
        }
      } else {
        return !!v || "Required";
      }
    },
    // v ? : !!v || "Required"},
    // (v) => (v && !!v.number) || "required",
  ],
  companyRequired: [
    (v) => Boolean(Object.keys(v || {})[0]) || "Company is required",
  ],
  nameRules: [
    (v) => !!v || "Name is required",
    (v) => (v && v.length <= 20) || "Name must be less than 20 characters",
  ],
  charLengthRules: [
    (v) => !!v || "Code is required",
    (v) =>
      (v && v.length >= 4 && v.length <= 8) ||
      "Code must be min 4 & max 8 characters",
  ],
  charLengthNewRules: [
    (v) => !!v || "Code is required",
    (v) => (v && v.length >= 20) || "Code must be min 4 & max 20 characters",
  ],
  emailRules: [
    (v) => !!v || "E-mail is required",
    (v) =>
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) || "E-mail must be valid",
  ],
  email: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0 && v != null) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(v) || "Invalid e-mail.";
    }
  },
  emailRulesOptional: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0 && v != null) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(v) || "E-mail must be valid";
    }
  },
  phone: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0 && v != null) {
      const pattern = /^(?:[0-9]{9,12}|)$/;
      return (
        pattern.test(v) ||
        "Please enter valid mobile number. Just the 9-12 numbers!"
      );
    }
  },
  phoneRequired: (value) => !!value || "",
  phoneNumberLength: (v) => (v && v.length == 15) || "Must be 10 digits.",
  phoneNumberLengthWithCountryCodeFunction: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0) {
      return v.length == 15 || "Must be 10 digits.";
    }
  },
  phoneNumberLengthWithCountryCodeFunctionAlerts: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0) {
      return v.length == 11 || "Must be 10 digits.";
    }
  },
  passwordRules: [
    (v) => !!v || "Password is required",
    (v) => (v && v.length >= 5) || "Password must have 5+ characters",
    (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
    (v) => /(?=.*\d)/.test(v) || "Must have one number",
    (v) => /([!@#$%&])/.test(v) || "Must have one special character [!@#$%&]",
  ],
  historyNumber: [(v) => (v > -1 && v <= 180) || "Must Be between 0-180"],
  phoneNumberWithMask: [
    (v) => !!v || "Required field",
    (v) => {
      if (v) {
        v = v.replace(/[- )(]/g, "");
      }
      return (
        /^(?:[0-9]{9,12}|)$/.test(v) ||
        "Please enter valid mobile number. Just the 9-12 numbers!"
      );
    },
  ],
  phoneNumber: [
    (v) => !!v || "Required field",
    (v) =>
      /^(?:[0-9]{9,12}|)$/.test(v) ||
      "Please enter valid mobile number. Just the 9-12 numbers!",
  ],
  OnlyPhoneNumberWithMask: [
    (v) => {
      if (v) {
        v = v.replace(/[- )(]/g, "");
      }
      return (
        /^(?:[0-9]{9,12}|)$/.test(v) ||
        "Please enter valid mobile number. Just the 9-12 numbers!"
      );
    },
  ],
  OnlyPhoneNumberWithMaskOptional: (v) => {
    if (!v) {
      return true;
    } else if (v.length > 0) {
      if (v) {
        v = v.replace(/[- )(]/g, "");
      }
      return (
        /^(?:[0-9]{9,12}|)$/.test(v) ||
        "Please enter valid mobile number. Just the 9-12 numbers!"
      );
    }
  },
  OnlyphoneNumber: [
    (v) =>
      /^(?:[0-9]{9,12}|)$/.test(v) ||
      "Please enter valid mobile number. Just the 9-12 numbers!",
  ],
  acceptPositiveNumberRules: [
    (v) => !!v || "required",
    (v) => parseInt(v) >= 0 || "Please enter positive number",
  ],
  acceptFloatHours: [
    (v) => !!v || "required",
    (v) => parseFloat(v) >= 0 || "Please enter positive number",
  ],
  acceptFloatNumberRules: [
    (v) => !!v || "required",
    (v) =>
      /^([+-]?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?)$/.test(v) ||
      "Please enter valid numbers!",
  ],
};
export default rules;
